export default "__VITE_ASSET__63667b36__"